export default [{
	path: 'documents',
	component: () => import('../../views/documents/home'),
	redirect: 'documents/sso',
	children: [{
		path: 'sso',
		component: () => import('../../views/documents/components/sso')
	}, {
		path: 'ssoWeb',
		component: () => import('../../views/documents/components/ssoWeb')
	}, {
		path: 'ssoApp',
		component: () => import('../../views/documents/components/ssoApp')
	}, {
		path: 'web_Exe',
		component: () => import('../../views/documents/components/web_Exe')
	}, {
		path: 'Log_Course_Experiment',
		component: () => import('../../views/documents/components/Log_Course_Experiment')
	}]
}]